export const profileModule = {};
